//console.log(tgblResourcesFrontend)

const resourcesList = ($) => {

  if (!window.Tangible) return
  const ajax = window.Tangible.ajax
  const ajaxConfig = window.Tangible.ajaxConfig
  const tangibleSelect = window.Tangible.Select

  // Global object
  window.resourcesList = {}

  $(document).ready(function () {
    window.resourcesList.init.constructor()
  })

  window.resourcesList.init = {

    // initialize the code
    constructor: function () {
      const parent = $('.tgbl-resources-list-wrap')
      if(parent.length) {
        this.saveToDashboard(parent)
        this.removeSaved(parent)
        this.loadMore(parent)
        this.openModal(parent)
        this.copyLinkToClipboard(parent)
        this.toolTip(parent)

      }

      const select_parent = $('.tgbl-resource-filters-wrap')
      if(select_parent.length) {
        this.select2Init(select_parent)
        this.resourceFilters(select_parent)
      }

      const category_parent = $('.tgbl-resources-wrap')
      if(category_parent.length) {
        this.categorySearch(category_parent)
      }
    },


    categorySearch: function(parent) {

      const s = parent.find('select.category')
      s.tangibleSelect()

      const cat_search = parent.find('.category')
      const origin = window.location.origin
      const pathname = window.location.pathname

      const url = origin+pathname

      cat_search.on('change', function(){

        const reload_url = $(this).val() ? url+'?category='+$(this).val() : url
        window.location.assign(url+'?category='+$(this).val())
      })
    },

    resourceFilters: function(select_parent) {

      // Toggle filters panel

      const filters = select_parent.find('.filters')
      const toggler = filters.find('.toggle-filter-content')
      const collapsible = filters.find('.collapsible-filter-content')
      toggler.removeClass('is-expanded').addClass('is-collapsed')
      collapsible.slideUp()

      $('body').on('click','.toggle-filter-content',  function(e){

        e.stopImmediatePropagation()
        //console.log($(this))

        const c = $(this).parents('.filters').find('.collapsible-filter-content')
        if($(this).hasClass('is-collapsed')){
          $(this).removeClass('is-collapsed').addClass('is-expanded')
          c.slideDown()
        }else if($(this).hasClass('is-expanded')){
          $(this).removeClass('is-expanded').addClass('is-collapsed')
          c.slideUp()
        }
      })

      // on select filters change, hide load more button
      select_parent.on('change','select.filter',  function(){
        const parent = $('.tgbl-resources-list-wrap.all-resources-wrap')
        const $button = parent.find('.load-more-button')
        $button.hide()
        select_parent.find('.action.apply-filters').addClass('apply')
      })

      // apply-filters click
      select_parent.on('click','.action.clear-filters' ,function (){
        select_parent.find('select').each(function(){
          $(this).val(0).trigger('change')
        })
        select_parent.find('.action.apply-filters').trigger('click')
      })

      select_parent.on('click','.action.apply-filters' ,function (){

        const $this = $(this)

        const search_input_selector = tgblResourcesFrontend.algolia_autocomplete == 'yes' ? '.aa-Input' : '.search-input'
        const search =  $('.tgbl-resource-search-box-wrap').find(search_input_selector)
        //console.log(search.val())

        const total_found_number = select_parent.find('.tgbl-choice-response .total-found-number')
        const showing_pages_number = select_parent.find('.tgbl-choice-response .showing-pages-number')
        const parent = $('.tgbl-resources-list-wrap.all-resources-wrap')
        const $button = parent.find('.load-more-button')
        const total = select_parent.find('#filters_data').attr('data-total')
        const current_url = select_parent.find('#filters_data').attr('data-current_url')
        const per_page = select_parent.find('#filters_data').attr('data-per_page')
        const columns = select_parent.find('#filters_data').attr('data-columns')
        const searched_category = select_parent.find('#filters_data').attr('data-searched_category')

        $button.show()
        tgblResourcesFrontend.current_page = 1

        // collect all filters selected

        let all_selected_filters = []
        let filters = {}
        select_parent.find('.filter').each(function(){
          filters[$(this).attr('data-type')] =  $(this).val()
          all_selected_filters =  $.merge( all_selected_filters, $(this).val() )
        })

        const data = {
          'filters': filters,
          'all_filters': all_selected_filters,
          'columns' : columns,
          'per_page' : per_page,
          'total' : total,
          'current_url' : current_url,
          'searched_category' : searched_category,
          'search' : search.val(),
        };

        //console.log(data)

        // spinner
        const spinnerHtml = $(tgblResourcesFrontend.spinnerHtml)
        const resource_list = $this.parents('.tgbl-resources-wrap').find('.tgbl-resources-list-wrap.all-resources-wrap')
        resource_list.css('opacity','0.5')
        resource_list.append(spinnerHtml)
        // ajax handle filters

        ajax('tgbl_filters_ajax', data)
          .then(function (res) {
            //console.log('RESPONSE --- ', res)
            $this.removeClass('apply')

            parent.find('.tgbl-resources-list.all-resources').html(res.html)

            showing_pages_number.html(' '+res.items_loaded)
            total_found_number.html(' '+res.total_found)
            $button.parents('.tgbl-resource-load-more-wrap').find('.total-found-number').html(' '+res.total_found)
            $button.parents('.tgbl-resource-load-more-wrap').find('.showing-pages-number').html(' '+res.items_loaded)

            resource_list.css('opacity','1')
            spinnerHtml.remove()

            if (res.has_loaded === 1) {
              $button.parents('.tgbl-resource-load-more-wrap').find('#load_more_data').attr('data-items_loaded',res.items_loaded)
            } else if (res.has_loaded === 0) {
              $button.hide()
            }
          })
          .catch(function (err) {
            console.log('error - ', err)
          }) // end ajax
      })// end click
    },


    loadMore: function (parent) {

      const button_data = parent.find('#load_more_data')
      const button = parent.find('.load-more-button')
      const showing_pages_number = $('.tgbl-resource-filters-wrap').find('.tgbl-choice-response .showing-pages-number')
      const total = button_data.attr('data-total')
      const current_url = button_data.attr('data-current_url')
      const per_page = button_data.attr('data-per_page')
      const columns = button_data.attr('data-columns')
      const searched_category = button_data.attr('data-searched_category')

      button.on('click', function(){

        const this_parent =$(this).parents('.tgbl-resources-list-wrap')

        const $button = $(this)

        const search_input_selector = tgblResourcesFrontend.algolia_autocomplete == 'yes' ? '.aa-Input' : '.search-input'
        const search =  $('.tgbl-resource-search-box-wrap').find(search_input_selector)

        const last_row_count = this_parent.find('.row').last().attr('data-counter')
        let all_selected_filters = []
        let filters = {}
        let items_loaded = button_data.attr('data-items_loaded')

        //parent.parents("#tgbl_resources_wrap").find('.filter').each(function(){
        this_parent.parents("#tgbl_resources_wrap").find('.filter').each(function(){
          filters[$(this).attr('data-type')] =  $(this).val()
          all_selected_filters =  $.merge( all_selected_filters, $(this).val() )
        })

        $button.text(tgblResourcesFrontend.localized.loading);

        const data = {
          'action': 'loadmore',
          'items_loaded': items_loaded,
          'page' : tgblResourcesFrontend.current_page,
          'columns' : columns,
          'per_page' : per_page,
          'total' : total,
          'filters': filters,
          'all_filters': all_selected_filters,
          'last_row_count': last_row_count,
          'current_url': current_url,
          'searched_category' : searched_category,
          'search' : search.val(),
        };


        // ajax handle load more

        ajax('tgbl_load_more_ajax', data)
          .then(function (res) {
            //console.log('RESPONSE --- ', res)

            tgblResourcesFrontend.current_page++
            $button.text(tgblResourcesFrontend.localized.loadmore)
            if ( tgblResourcesFrontend.current_page == tgblResourcesFrontend.max_page ) $button.hide();

            if (res.has_loaded === 1) {
              this_parent.find('.tgbl-resources-list.all-resources').append(res.html)
              $button.parents('.tgbl-resource-load-more-wrap').find('#load_more_data').attr('data-items_loaded',res.items_loaded)
              showing_pages_number.html(' '+res.items_loaded)
              $button.parents('.tgbl-resource-load-more-wrap').find('.showing-pages-number').html(' '+res.items_loaded)

            } else if (res.has_loaded === 0) {
              $button.hide();
            }
          })
          .catch(function (err) {
            console.log('error - ', err)
          }) // end ajax
      }) // end click
    },


    removeSaved: function (parent) {

      $('body').on('click','.action.remove',function(){
        const $this = $(this)
        const user_id = $this.attr('data-user_id')
        const resource_id = $this.attr('data-resource_id')

        //console.log(resource_id)
        const data = {
          user_id: user_id,
          resource_id: resource_id,
        }

        // ajax handle user saved resource remove

        ajax('tgbl_remove_user_saved_resource_ajax', data)
          .then(function(res) {
            //console.log('RESPONSE --- ',  res)
            if(res === 1){
              //$this.parents('.row').remove()
              $this.parents('#tgbl_resource_card_'+resource_id).next('hr').remove()
              $this.parents('#tgbl_resource_card_'+resource_id).remove()
            }
          })
          .catch(function(err) {
            console.log('error - ',  err)
          }) // end ajax
      }) // end click

    },


    saveToDashboard: function (parent) {

      $('body').on('click','.action.dashboard',function(){
        const $this = $(this)
        const user_id = $this.attr('data-user_id')
        const resource_id = $this.attr('data-resource_id')

        const data = {
          user_id: user_id,
          resource_id: resource_id,
        }

        // ajax handle user save resource

        ajax('tgbl_user_saved_resource_ajax', data)
          .then(function(res) {
            //console.log('RESPONSE --- ',  res)
            $this.attr('data-saved',res)
            if(res === 1){
              $this.addClass('saved')
            } else if(res === 0){
              $this.removeClass('saved')
            }
          })
          .catch(function(err) {
            console.log('error - ',  err)
          }) // end ajax
      }) // end click
    },


    toolTip: function(parent) {

      $( 'body' ).tooltip({
        items: '[data-tooltip_view],[data-tooltip_save],[data-tooltip_download],[data-tooltip_visit],[data-tooltip_copy]',
        content: function() {
          const element = $( this )
          return element.text()
        }
      })
    },


    copyLinkToClipboard: function(parent) {

      const clipboard = new ClipboardJS('.action.share')

      clipboard.on('success', function(e) {
        //console.log('Action:', e)
        //console.log('Text:', e.text)
        //console.log('Trigger:', e.trigger)

        $('body').on('mouseover','.action.share', function(){
          $( 'body' ).tooltip({
            items: '[data-tooltip_view],[data-tooltip_save],[data-tooltip_download],[data-tooltip_visit],[data-tooltip_copy]',
            content: function() {
              const element = $( this )
              return element.text()
            }
          })
        })

        $( 'body' ).tooltip({
          items: '[data-tooltip_view],[data-tooltip_save],[data-tooltip_download],[data-tooltip_visit],[data-tooltip_copy]',
          content: function() {
            const element = $( this )
            if ( element.is( "[data-tooltip_copy]" ) ) {
              return 'Copied!'
            }
            return element.text()
          }
        })
        e.clearSelection()
      })

      clipboard.on('error', function(e) {
        //console.log('Action:', e.action)
        //console.elog('Trigger:', e.trigger)
      })
    },


    openModal: function(parent) {

      // open modal on load if resource id passed by URL
      const url_resource_id = tgblResourcesFrontend.resource_id
      if(url_resource_id!=0){

        const data = {
          'resource_id': url_resource_id,
          'columns': 3,
        };

        // spinner
        const spinnerHtml = $(tgblResourcesFrontend.spinnerHtml)
        $( 'body' ).append(spinnerHtml)
        spinnerHtml.find('.tgbl-ajax-modal-spinner').show()

        // ajax response modal

        ajax('tgbl_view_modal_ajax', data)
          .then(function (res) {
            console.log('RESPONSE --- ', res)
            $(res).appendTo('body').modal({
              showSpinner: false,
            })
            spinnerHtml.remove()
          })
          .catch(function (err) {
            console.log('error - ', err)
            spinnerHtml.remove()
          }) // end ajax
      }

      // open modal on click
      $('body').on('click','.action.view',  function(event){
        event.preventDefault()

        const resource_id = $(this).attr('data-resource_id')
        const columns = $(this).attr('data-columns')

        const data = {
          'resource_id': resource_id,
          'columns': columns,
        };

        // spinner
        const spinnerHtml = $(tgblResourcesFrontend.spinnerHtml)
        $( 'body' ).append(spinnerHtml)
        spinnerHtml.find('.tgbl-ajax-modal-spinner').show()

        // ajax response modal

        ajax('tgbl_view_modal_ajax', data)
          .then(function (res) {
            //console.log('RESPONSE --- ', res)
            $(res).appendTo('body').modal({
              showSpinner: true,
            })
            spinnerHtml.remove()
          })
          .catch(function (err) {
            console.log('error - ', err)
            spinnerHtml.remove()
          }) // end ajax
      })
    },


    select2Init: function (select_parent) {
      // Tags select2 //
      const s = select_parent.find('select')
      s.tangibleSelect()
    },
  }
}

export { resourcesList }

